<template>
  <div align="center">
    <br />
    <h1>Sua conta</h1>
    <br />
    {{ user.name }}<br />
    {{ user.email }}<br />
    {{ user.phone }}<br />
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Account",
  computed: {
    ...mapState(["user"]),
  },
};
</script>
<style scope></style>
